<router-outlet>
</router-outlet>
<ngx-ui-loader *ngIf="!hideLoader"></ngx-ui-loader>